import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, Grid, Button, Accordion, AccordionSummary, AccordionDetails, TextField } from "@material-ui/core";
import {
  ValidatorForm,
} from "react-material-ui-form-validator";
import { Save } from "@material-ui/icons";
import { useForm } from "../../../hooks/useForm";
import {
  MENU_CONTRATACIONES,
} from "../../../utils/constants";
import { guardarInclusionesExclusiones, obtenerInclusionesExclusiones } from "../../../actions/contrataciones/contratacionesInclusionesExclusiones";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from "moment";

export const InclusionesExclusiones = (props) => {
  const dispatch = useDispatch();
  const {
    inclusionesExclusiones
  } = useSelector((state) => state.contratacionesInclusionesExclusiones);

  const [
    formValues,
    handleInputChange,
    ,
    ,
    ,
    ,
    ,
    ,
    setearVariosValores,
  ] = useForm(
    inclusionesExclusiones === null ? {
      inclusiones: "",
      exclusiones: "",
    } : inclusionesExclusiones
  );

  const {
    inclusiones,
    exclusiones,
  } = formValues;

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(guardarInclusionesExclusiones(formValues));
  };


  useEffect(() => {
    dispatch(obtenerInclusionesExclusiones());
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    if(inclusionesExclusiones !== null){
      setearVariosValores({
        inclusiones: inclusionesExclusiones.inclusiones,
        exclusiones: inclusionesExclusiones.exclusiones,
      })
    }
    // eslint-disable-next-line
  }, [inclusionesExclusiones]);

  return (
    <>
      <ValidatorForm onSubmit={submitHandler}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {
              inclusionesExclusiones !== null &&
            
            <Typography style={{marginBottom:'1rem'}}>Fecha de carga: {moment(inclusionesExclusiones.fechaCarga).format("DD/MM/YYYY")}</Typography>
          }
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel1a-content`}
                id={`panel1a-header`}
              >
                <Typography>Inclusiones</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container>
                  <Grid item xs={12}>
                    <TextField
                      name={"inclusiones"}
                      fullWidth
                      margin="normal"
                      value={inclusiones || ""}
                      onChange={handleInputChange}
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                      multiline
                      variant="outlined"
                      rows={4}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
            <Accordion style={{ marginTop: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel2a-content`}
                id={`panel2a-header`}
              >
                <Typography>Exclusiones</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container>
                  <Grid item xs={12}>
                  <TextField
                      fullWidth
                      margin="normal"
                      name="exclusiones"
                      value={exclusiones || ""}
                      onChange={handleInputChange}
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                      multiline
                      variant="outlined"
                      rows={4}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>

        </Grid>
        {props.menu !== MENU_CONTRATACIONES.CONSULTA && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<Save />}
            >
              Guardar datos
            </Button>
          </div>
        )}
      </ValidatorForm>
    </>
  );
};
